// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__39fg6","icon":"SortAdornment_icon__2l6CO","up":"SortAdornment_up__3gFXH","down":"SortAdornment_down__r_zIZ","active":"SortAdornment_active__2Edpl"};